<template>
    <div class="treeContent">
        <el-tree class="ztree" node-key="sceneCode" ref="tree" :data="treeData" :props="defaultProps"
            :render-content="renderContent" :default-expanded-keys="defaultKeys" :current-node-key="nodeKey"
            highlight-current accordion @node-click="handleNodeClick" @node-drag-end="handleDragEnd" draggable
            :allow-drop="allowDrop" :allow-drag="allowDrag"></el-tree>
    </div>
</template>

<script>
import { shareTree } from '@/api/modules/public.js';
import { sceneDelScene, sceneDragSort } from '@/api/modules/architecture.js';
import bus from '@/utils/bus.js';

export default {
    // props:['defaultTreeObj'],
    data() {
        return {
            isAllow: true,
            treeData: [],
            defaultKeys: [],
            nodeKey: '',
            defaultProps: {
                children: 'item',
                label: 'label'
            },
            // 点击选中的树结构
            clickTreeObj: {},
            // 选中的树结构的父节点数据
            parentData: {}
        };
    },
    mounted() {
        this.initTree();
        this.refreshTree();
    },
    methods: {
        initTree() {
            this.getTree();
        },
        setDefault(obj) {
            this.$nextTick(() => {
                this.nodeKey = obj.sceneCode;
                this.defaultKeys = [obj.sceneCode];
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.nodeKey);
                });
            });
        },
        // 更新树
        refreshTree() {
            bus.$on('addSuccess', () => {
                this.getTree();
            });
        },
        async getTree(obj = '') {
            let query = {};
            // 根据不同角色账户传递不同参数 获取不同树
            if (this.$store.state.type === 3 || this.$store.state.type === 2) {
                query = { idEdit: 0, all: true };
            } else {
                query = { idEdit: 0 };
            }
            let { result } = await shareTree(query);
            // 空数组保护：避免 result.item[0] 抛错
            const treeItems = (result && result.item) || [];
            if (treeItems.length > 0 && treeItems[0].scene_code === 'all_node') {
                treeItems[0].label = this.$t('public.All');
            }
            this.$store.commit('SET_TREE_DATA', treeItems);

            if (this.$store.state.type === 3 || this.$store.state.type === 2) {
                this.treeData = treeItems.slice(1);
            } else {
                this.treeData = treeItems;
            }
            if (obj) {
                this.setDefault(obj);
            }
            // 新增成功后的默认展开以及选中
            else if (Object.keys(this.clickTreeObj).length !== 0) {
                this.setDefault(this.clickTreeObj);
            } else {
                this.setDefault(this.treeData[0]);
            }
        },
        renderContent(h, { node, data, store }) {
            const styleJsx = {
                float: 'right',
                display: data.level === 0 ? 'none' : 'inline-block'
            };
            return (
                <div class="custom-tree-node" style="width:100%;padding-right:15px">
                    <i class={this.iconFn(data)}></i>
                    <span style="margin-left:5px">{node.label}</span>

                    <span style={styleJsx}>
                        <i class="el-icon-delete icon" on-click={() => this.remove(data)}></i>
                    </span>
                </div>
            );
        },
        iconFn(data) {
            if (data.level === 0) return 'iconfont icon-kehu';
            //nodeType==2时funcType（0-什么都不关联、1-平面图、2-地图、3-双属性节点）
            else if (data.nodeType === 2) {
                switch (data.funcType) {
                    case 0: {
                        return 'iconfont icon-zuzhijiagou';
                    }
                    case 1: {
                        return 'el-icon-picture';
                    }
                    case 2: {
                        return 'iconfont icon-ditu';
                    }
                    case 3: {
                        return 'el-icon-menu';
                    }
                    default:
                        break;
                }
            }
        },
        remove(data) {
            this.$confirm(this.$t($t('integration.this_operation_will_delete_its_child_nodes_and_monitoring_points_dot__do_you_want_to_continue_q')))
                .then(() => {
                    this.deleteFn();
                })
                .catch(() => { });
        },
        deleteFn() {
            sceneDelScene({ id: this.clickTreeObj.sceneId }).then(({ state, result }) => {
                switch (result) {
                    case 200:
                        bus.$emit('delSuccess', this.parentData);
                        this.getTree({ sceneCode: this.clickTreeObj.parentCode });
                        this.$message.success($t('integration.successfully_deleted'));
                        break;
                    case 400:
                        this.$message.error($t('integration.delete_failed'));
                        break;
                    case 401:
                        this.$message.error($t('integration.parameter_error'));
                        break;
                    case 402:
                        this.$message.error($t('integration.the_deleted_schema_is_a_scope_and_cannot_be_deleted'));
                        break;
                    case 403:
                        this.$message.error($t('integration.the_schema_is_in_use_and_cannot_be_deleted'));
                        break;
                }

            });
        },
        handleNodeClick(data, node, ownNode) {
            if (data.level !== 0) {
                this.parentData = node.parent.data;
            } else {
                // 等于本身
                this.parentData = data;
            }
            this.clickTreeObj = { ...data };
            bus.$emit('nodeClickTree', data);
        },
        // 树形拖拽  平级拖拽

        // 拖拽结束后 只触发一次
        handleDragEnd(draggingNode, dropNode, dropType, ev) {
            if (!this.isAllow) return this.$message.warning($t('integration.only_peer_nodes_are_allowed_to_drag'));
            sceneDragSort({ currentId: draggingNode.data.sceneId || draggingNode.data.scopeId, targetId: dropNode.data.sceneId || dropNode.data.scopeId }).then(({ state, result }) => {
                if (state.code === 200 && result) {
                    this.$message.success($t('integration.drag_succeeded'));
                }
            });
        },
        /**
         *
         * @param {*拖拽节点} draggingNode
         * @param {*被放置目标节点} dropNode
         * @param {*插入目标前后和本身} type
         * 1. 判断是否能拖拽
         * 2. 判断是否是 同客户下
         * 3. 如果不同 则isAllow设置为false 进行提示
         */
        allowDrop(draggingNode, dropNode, type) {
            if (draggingNode.data.level === dropNode.data.level) {
                this.isAllow = true;
                if (draggingNode.data.parentCode === dropNode.data.parentCode) {
                    return type === 'prev' || type === 'next';
                }
            } else {
                this.isAllow = false;
                // 不同级进行处理
                return false;
            }
        },
        allowDrag(draggingNode) {
            return true;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/styles/tree.scss';

.treeContent {
    height: calc(100% - 50px);
    overflow: auto;
}

.custom-tree-node {
    width: 100%;
    display: flex;
    padding-right: 15px;
    box-sizing: border-box;
    justify-content: space-between;

    i {
        color: #c0c4cc;
        margin-right: 10px;
        font-size: 18px;

        &:hover {
            color: #c80101;
            font-weight: bold;
        }
    }
}

.ztree ::v-deep .el-tree-node.is-current>.el-tree-node__content i {
    color: #fff !important;
}
</style>
